module.exports = __webpack_public_path__ + "6a7dbc9c4512991ce19f32523dfca07a.svg";